var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 12 12",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M0 2h2m3 0h2m3 0h2M0 3h1m1 0h3m2 0h3m1 0h1M0 4h1m2 0h1m4 0h1m2 0h1M0 5h1m10 0h1M0 6h1m10 0h1M0 7h1m10 0h1M0 8h1m10 0h1M0 9h1m10 0h1M0 10h12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#e5cd47",
    d: "M1 3h1m3 0h2m3 0h1M1 4h2m1 0h4m1 0h2M1 8h2m6 0h2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#bca73c",
    d: "M1 5h3m4 0h3M1 9h4m2 0h4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#e8a127",
    d: "M4 5h4M1 6h1m2 0h1m2 0h1m2 0h1M1 7h1m2 0h1m2 0h1m2 0h1M3 8h6M5 9h2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ffa154",
    d: "M2 6h1m5 0h1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff3200",
    d: "M3 6h1m5 0h1M2 7h1m5 0h1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ffe7a8",
    d: "M5 6h1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff9321",
    d: "M6 6h1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ce0000",
    d: "M3 7h1m5 0h1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff7200",
    d: "M5 7h1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#d64000",
    d: "M6 7h1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAction);
export default __webpack_public_path__ + "static/media/action.77d69bc2af786c7749d5fda2fed8676c.svg";
export { ForwardRef as ReactComponent };